module.exports = __webpack_public_path__ + "static/media/itau.13ea5e40.png";